import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import QuestionList from './QuestionList';
import QuestionCreation from './QuestionCreation';
import QuestionUpdate from './QuestionUpdate';


export default class Question extends React.Component {

    render() {
        return (
            <Switch>
                <Route path="/questions/new/:questionType(multiple_choice|single_choice)" component={QuestionCreation}/>
                <Route exact path="/questions/:questionId(\w+)" component={QuestionUpdate}/>
                <Route path="/questions" component={QuestionList}/>
                <Redirect to="/questions"/>
            </Switch>
        );
    }
}
